export function isNumber(n: string | number | undefined): n is number {
   if(n === undefined)
      return false;
   const numberToCheck = typeof n == "number" ? n : parseFloat(n);
   return !isNaN(numberToCheck) && isFinite(numberToCheck);
}